import { isUndefined } from 'lodash';
import { LiqPrefLedgerItem } from 'api';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import { LiquidationPreferenceLedgerParser } from './liquidation-preference.types';

const liqPrefLedgerParser: LiquidationPreferenceLedgerParser = params => {
  const { columns, rowConfig, tableData } = params;
  const alphabet = alphabetGenerator([], columns.length);
  let cells = {};
  const { currentSecurity, isUsingByExitDate } = tableData;
  const investmentDate = currentSecurity?.investment_date ?? null;

  columns.forEach((column, colIndex) => {
    const columnKey = alphabet[colIndex];
    rowConfig.forEach((row, rowIndex) => {
      const rowNumber = rowIndex + 1;
      const cellKey = `${columnKey}${rowNumber}`;
      const value = !isUndefined(column[row.alias as keyof LiqPrefLedgerItem])
        ? column[row.alias as keyof LiqPrefLedgerItem]
        : null;
      let newValue;

      switch (row.dbType) {
        case 'boolean':
          newValue = Number(value);
          break;
        case 'dbDate':
          if (isUsingByExitDate && investmentDate && colIndex === 0) {
            newValue = investmentDate;
          } else if (isUsingByExitDate && value && colIndex !== 0) {
            newValue = value;
          }
          break;
        default:
          newValue = value;
          break;
      }

      cells = {
        ...cells,
        [cellKey]: {
          ...row,
          value: newValue,
          entityId: column.id,
          key: cellKey,
          alias: row.alias,
          columnLegend: columnKey,
        },
      };
    });
  });

  return cells;
};

export default liqPrefLedgerParser;
